import { Nullable } from 'src/core/common/domain/types/types';

export type NfcToolsConfigurationPrimitives = {
  can_record_location: boolean;
  can_record_general: boolean;
  can_read: boolean;
};

export class NfcToolsConfiguration {
  private constructor(private readonly primitives: NfcToolsConfigurationPrimitives) {}

  static fromPrimitives(primitives: Nullable<Partial<NfcToolsConfigurationPrimitives>>): NfcToolsConfiguration {
    return new NfcToolsConfiguration({
      can_record_location: primitives?.can_record_location ?? false,
      can_record_general: primitives?.can_record_general ?? false,
      can_read: primitives?.can_read ?? false,
    });
  }

  toPrimitives(): NfcToolsConfigurationPrimitives {
    return { ...this.primitives };
  }

  canRecordLocation(): boolean {
    return this.primitives.can_record_location;
  }

  canRecordGeneral(): boolean {
    return this.primitives.can_record_general;
  }

  canRead(): boolean {
    return this.primitives.can_read;
  }

  hasAnyTool(): boolean {
    return this.canRecordLocation() || this.canRecordGeneral() || this.canRead();
  }
}
